import React, { Fragment } from "react";
import HomeSliderCSS from "./HomeSlider.module.scss";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import slide1 from "../../assets/images/common/slide_one.png";
// import slide2 from "../../assets/images/common/slide_two.png";
// import slide3 from "../../assets/images/common/slide_three.png";
// import slide4 from "../../assets/images/common/slide_four.png";
// import { useRef } from "react";
// const data = [slide1, slide2, slide3, slide4];
import singlebanner from "../../assets/images/common/banner_logo.svg";
const HomeSlider = () => {
  // const homeSlider = useRef()
  return (
    <Fragment>
      <div className={`${HomeSliderCSS.HomesliderMain}`}>
        <div className="container">
          <div className={`${HomeSliderCSS.HomesliderWrapper}`}>
            <div className={`text-center ${HomeSliderCSS.homesinglrbanner}`}>
             <img src={singlebanner} alt="Home Banner"/>
            </div>
            {/* <OwlCarousel
                className={`owl-theme homeSlider__owl`}
                loop
                dots={false}
                items={1}
                nav
                ref={homeSlider}
              >
                {data.map((img, index) => {
                  return (
                    <div class="item" key={index} >
                      <div className={`slider${index+1}`}></div>
                    </div>
                  );
                })}
              </OwlCarousel> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomeSlider;
